export enum DispatchStatus {
    PENDING = "Pending Dispatch",
    APPROVED = "Dispatch Approved",
    CLOSED = "Closed",
}
